// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container__3oJRC","tab":"style__tab__3_qHE","selected":"style__selected__2bqv6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account_page/tabs/style.scss
// module id = 1044
// module chunks = 0